import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Form,
  Card,
  Divider,
  Tag,
  Popconfirm,
  Row,
  Col,
  notification,
} from 'antd';
import Fieldset from 'components/Fieldset';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import ThirdPartyInput from 'components/ThirdPartyInput';
import { FormInstance } from 'antd/lib/form';
import DataGrid from 'components/DataGrid';
import FormItem from 'antd/lib/form/FormItem';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  PropThirdPartyRequest,
  removeProposalThirdParty,
  updateProposalThirdPartyStatus,
} from 'services/proposal';
import DeleteButton from 'components/DeleteButton';
import { useFormList } from 'hooks/useFormList';
import NewButton from 'components/NewButtonSmall';
import Tpdisplay from './Tpdisplay';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import Button from 'components/ButtonSmall';
import IProcess from 'icons/IProcess';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import BrokerInput from 'components/BrokerInput';
import ParListSelectVendor from 'components/ParListSelectVendor';
import ParListSelectBranche from 'components/ParListSelectBranche';
import { noop } from 'lodash';
import ParListSelectUserSales from 'components/ParListSelectUserSales';
import ModalControllerNV from 'components/ModalControllerNV';
import moment from 'moment';
import GetLabel from 'DisplayFramework/components/GetLabel';
export type EntitySelectedValue = {
  tpidbroker?: number;
  brokerreference?: string;
  brokername?: string;
};
export type ThirdPartiesProps = {
  form: FormInstance;
  onChange?: (entity?: any) => void;
  onChangeTplist?: any;
  value?: EntitySelectedValue;
  reftech?: () => void;
  isProposalCreate?: boolean;
};

const ThirdParties = ({
  reftech,
  form,
  value,
  onChange = noop,
  onChangeTplist = noop,
  isProposalCreate,
  ...otherProps
}: ThirdPartiesProps) => {
  const { add: addtp, remove: removetp } = useFormList(form, 'thirdparties', {
    idKey: 'tpid',
    addAsFirst: true,
  });
  const handleadd = (obj: PropThirdPartyRequest) => {
    addtp(obj);
    notification.success({ message: obj.tpname + ' Created with success' });
  };
  const [tpList, settpList] = useState<any[]>();

  const [loading, setloading] = useState<boolean>(false);

  // const handleSelectThirdparty = (item: any) => {
  //   onChange(item);
  //    value = { tpidbroker: item.tpidbroker, brokerreference: item.brokerreference, brokername: item.brokername };

  // };

  useEffect(() => {
    onChangeTplist(tpList);
  }, [tpList]);

  const handleupdate = useCallback(
    (item: PropThirdPartyRequest) => {
      const values = form.getFieldValue(
        'thirdparties'
      ) as PropThirdPartyRequest[];
      const newValues = values.map((elem, i) => {
        if (item.tpid !== elem.tpid) {
          return elem;
        }
        const updatedItem = { ...elem, ...item };

        return {
          ...updatedItem,
        };
      });
      form.setFieldsValue({
        thirdparties: newValues,
      });
      notification.success({ message: item.tpname + ' Updated with success' });
    },
    [form]
  );
  const updateStatus = (tproleid: number, status: string, index: number) => {
    setloading(true);
    updateProposalThirdPartyStatus({ tproleid: tproleid, status: status })
      .then((response) => {
        setloading(false);
        if (response.code === '200') {
          const listtp = form.getFieldValue('thirdparties');
          listtp[index].status = status;

          if (status === 'ACTIVE') {
            listtp[index].enddate = '';
          } else {
            listtp[index].enddate = toDatePickerDate(
              String(moment().format('YYYY-MM-DD'))
            );
          }
          form.setFieldsValue({
            thirdparties: listtp,
          });

          notification.success({ message: response.message });
        } else {
          notification.error({ message: response.message });
        }
      })
      .catch(() => {
        setloading(false);
      });
  };
  const columnsbeneficary = useMemo<DataGridColDef<PropThirdPartyRequest>[]>(
    () => [
      {
        comcode: 'tprole',
        dataIndex: 'tprolecode',
        key: 'tprolecode',
        render: (value, record, index) => {
          return record.tpid === 0 ||
            record.tprolecode === '' ||
            record.tprolecode === null ? (
            <Form.Item noStyle name={['thirdparties', index, 'tprole']}>
              <ParListSelect parcode="TPMAINROLE" />
            </Form.Item>
          ) : (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>
                  {' '}
                  {record.tprolecodelabel ?? value}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <Tpdisplay
                  visible={visible}
                  onCancel={() => {
                    setVisible(false);
                  }}
                  record={record}
                  tproleid={record.tproleid}
                  onsave={(item) => {
                    handleupdate(item);
                    setVisible(false);
                  }}
                  addorupdate="UPDATE"
                  reftech={reftech}
                />
              )}
            />
          );
        },

        fixed: 'left',
        width: 80,
      },
      {
        dataIndex: 'tpname',
        key: 'tpname',
        render: (value, record: any, index) => {
          return (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <ThirdPartyModal
                  tpId={record.tpid.tpid ?? record.tpid}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={record.tpreference + ' - ' + record.tpname}
                />
              )}
            />
          );
        },

        width: 120,
      },
      {
        dataIndex: 'startdate',
        key: 'startdate',
        width: 120,
        render: (value, record, index) => dateToString(value ?? ''),
      },
      {
        dataIndex: 'enddate',
        key: 'enddate',
        width: 120,
        render: (value, record, index) => dateToString(value ?? ''),
      },
      {
        dataIndex: 'status',
        key: 'status',
        render: (value, record, index) => {
          return value === 'VALID' || value === 'ACTIVE' ? (
            <Tag color="blue" key="ACTIVE">
              Activate
            </Tag>
          ) : (
            <Tag color="volcano" key="TERM">
              Terminate
            </Tag>
          );
        },

        width: 100,
      },

      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record, index) => (
          <>
            {record.tprolecode !== 'CLIENT' &&
              (record.status === 'TERMINATE' ? (
                <Button
                  icon={<IProcess />}
                  comcode="activate"
                  onClick={() => updateStatus(record.tproleid, 'ACTIVE', index)}
                />
              ) : (
                <Button
                  icon={<IProcess />}
                  comcode="Terminated"
                  onClick={() =>
                    updateStatus(record.tproleid, 'TERMINATE', index)
                  }
                />
              ))}
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => {
                if (record.isNew && record.tproleid < 0) {
                  removetp(record.tpid);
                } else {
                  let tp: any = record?.tpid;
                  let removetpidGuar = false;
                  if (
                    form.getFieldValue('guarantor')?.tpid === tp?.tpid &&
                    record.tprolecode === 'GUAR'
                  ) {
                    // removetpidGuarFromContract
                    removetpidGuar = true;
                  }
                  removeProposalThirdParty({
                    tproleid: record.tproleid,
                    removeGuar: removetpidGuar,
                  })
                    .then((res) => {
                      if (res.code === '200') {
                        notification.success({ message: res.message });
                        removetp(record.tpid);
                        form.setFieldValue('guarantor', null);
                      }
                    })
                    .catch((err) => {
                      notification.error({ message: err.message });
                    });
                }
              }}
            >
              <DeleteButton
                onlyIcon
                disabled={record.tprolecode !== 'GUAR'}
                style={{
                  border: record.tprolecode === 'GUAR' ? '1px solid red' : '',
                }}
              />
            </Popconfirm>
          </>
        ),
        fixed: 'right',
        width: 120,
      },
    ],
    [handleupdate, removetp, updateStatus]
  );

  return (
    <Card
      title={
        <GetLabel
          label="third-parties"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
    >
      <Fieldset comcode="third-parties">
        <FormInput col xs={24} md={12} name="client">
          <ThirdPartyInput role="CLIENT" />
        </FormInput>
        <FormInput col xs={24} md={12} name="borrower">
          <ThirdPartyInput role="BORROWER" />
        </FormInput>

        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => {
            return (
              <FormInput col xs={24} md={12} name="supplier">
                <ThirdPartyInput
                  role="SUPPLIER"
                  disabled={getFieldValue('prcode') === 'LEASEBACK'}
                />
              </FormInput>
            );
          }}
        </Form.Item>
        <FormInput col xs={24} md={12} name="guarantor">
          <ThirdPartyInput role="GUAR" />
        </FormInput>
      </Fieldset>

      <Divider />

      <Fieldset comcode="distribution">
        <Form.Item shouldUpdate={() => true} noStyle>
          {({ getFieldValue }) => {
            return (
              <FormInput col xs={24} md={6} name="ctnetworkcode">
                <ParListSelect
                  parcode="NETWORK"
                  offerid={getFieldValue('offerid')}
                />
              </FormInput>
            );
          }}
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => {
            const networkcode = getFieldValue('ctnetworkcode');

            return (
              <FormInput col xs={24} md={12} name="broker">
                <BrokerInput
                  networkcode={networkcode}
                  // onClear={() => {
                  //   form.setFieldValue('broker', null);
                  // }}
                />
              </FormInput>
            );
          }}
        </Form.Item>

        <Form.Item shouldUpdate={() => true} noStyle>
          {({ getFieldValue }) => {
            const tpidbroker = getFieldValue('broker')?.tpidbroker;
            return (
              <FormInput col xs={24} md={6} name="vendorid">
                <ParListSelectVendor
                  mgid={Number(localStorage.getItem('mgid'))}
                  tpidbroker={Number(tpidbroker)}
                />
              </FormInput>
            );
          }}
        </Form.Item>

        <Form.Item shouldUpdate={() => true} noStyle>
          {({ getFieldValue }) => {
            return (
              <FormInput col xs={24} md={6} name="channelcode">
                <ParListSelect
                  parcode="CHANNEL"
                  offerid={getFieldValue('offerid')}
                  disabled={
                    getFieldValue('ctnetworkcode')?.length > 0 &&
                    !isProposalCreate
                  }
                />
              </FormInput>
            );
          }}
        </Form.Item>
        <Form.Item shouldUpdate={() => true} noStyle>
          {({ getFieldValue }) => {
            return (
              <FormInput col xs={24} md={12} name="brid">
                <ParListSelectBranche
                  params={{
                    mgid: Number(localStorage.getItem('mgid')),
                    channelcode: getFieldValue('channelcode'),
                    brname: '',
                  }}
                  disabled={
                    getFieldValue('ctnetworkcode')?.length > 0 &&
                    !isProposalCreate
                  }
                />
              </FormInput>
            );
          }}
        </Form.Item>
        <Form.Item shouldUpdate={() => true} noStyle>
          {({ getFieldValue }) => {
            return (
              <FormInput col xs={24} md={6} name="ctsaleuserid">
                <ParListSelectUserSales
                  params={{
                    mgid: Number(localStorage.getItem('mgid')),
                    brid: Number(getFieldValue('brid')),
                  }}
                  disabled={
                    getFieldValue('ctnetworkcode')?.length > 0 &&
                    !isProposalCreate
                  }
                />
              </FormInput>
            );
          }}
        </Form.Item>
      </Fieldset>

      <Row>
        <Col span={22}></Col>
        <Col span={2}>
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <NewButton comcode="add" onClick={() => setVisible(true)} />
            )}
            modal={({ setVisible, visible }) => (
              <Tpdisplay
                visible={visible}
                onCancel={() => {
                  setVisible(false);
                }}
                onsave={(item) => {
                  if (
                    form
                      .getFieldValue('thirdparties')
                      .find((tp: any) => tp.tprolecode === item.tprolecode) !==
                      undefined &&
                    item.tprolecode === 'CLIENT'
                  )
                    notification.error({
                      message: "can't add more then one client !",
                    });
                  else {
                    handleadd(item);
                    setVisible(false);
                  }
                }}
                addorupdate="ADD"
              />
            )}
          />
        </Col>
        <FormItem shouldUpdate noStyle>
          {({ getFieldValue }) => {
            if (getFieldValue('thirdparties')?.length > 0) {
              settpList(getFieldValue('thirdparties'));

              return (
                <DataGrid
                  isLoading={loading}
                  rowKey="tproleid"
                  scroll={{ x: 1200, y: 600 }}
                  dataSource={getFieldValue('thirdparties')}
                  titleComcode="all thirdparties"
                  columns={columnsbeneficary}
                />
              );
            }
          }}
        </FormItem>
      </Row>
    </Card>
  );
};

export default ThirdParties;
